import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { Link } from "react-router-dom";

import UserStat             from '../../Component/ProfileUserStatValue'
import AddAttributeButton   from './Attributes/AddAttribute/AddAttributeButton';


class ProfileHeader extends Component<any, any> {
  render() {

    return (
      <div className="ProfileHeader">
        <div className="row">
          <div className="col-4 col-sm-4 col-lg-2">
            <img src={this.props.gravatar} alt="Gravatar: https://www.gravatar.com/"/>
          </div>
          <div className="col-6 col-sm-8 col-lg-10">
            <h1>{this.props.name}</h1>
            <span className="text-muted">{this.props.username}</span>
            <br /><br />
          </div>
          <br />
          <div className="col-4 col-sm-4 col-lg-2">
          </div>
        </div>
      </div>
    );
  }
}

export default observer(ProfileHeader);
